import script from "./log-list.vue?vue&type=script&setup=true&lang=js"
export * from "./log-list.vue?vue&type=script&setup=true&lang=js"

import "./log-list.vue?vue&type=style&index=0&id=ff13f60c&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff13f60c"]])

export default __exports__